"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { FaGoogle, FaEye, FaEyeSlash } from "react-icons/fa"
import config from "./config.json"
import Header from "./Header"
import "./UploadSection.css"
import img from "./signup.png"

function Signup({
  name,
  setIsRegisterModalOpen,
  setIsModalOpen,
  isModalOpen,
  isRegisterModalOpen,
  setIsLoggedIn,
  setUsername,
  setAccessKey,
  remainingCredits,
}) {
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [orgName, setOrgName] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [popupMessage, setPopupMessage] = useState("")
  const [showPopup, setShowPopup] = useState(false)
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const navigate = useNavigate()
  const [isLoggedIn, setIsLoggedInLocal] = useState(false)

  const [googleUserData, setGoogleUserData] = useState(null)
  const [showGoogleRegisterForm, setShowGoogleRegisterForm] = useState(false)

  // Registration function
  async function registerUser(userData) {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      })

      const data = await response.json() // Parse response JSON

      // Update the success condition to check for status 200
      if (data.status === 200) {
        return { success: true, data } // Successful registration
      } else if (data.status === 400 && data.message === "User already exist") {
        return { success: false, error: "User already exists" } // Return user already exists error
      } else {
        throw new Error(`${data.message}`)
      }
    } catch (error) {
      return { success: false, error: error.message } // Return error object
    }
  }

  async function login(username, password) {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
          product_name: "MAYAMAYA_LITE",
        }),
      })

      if (response.ok) {
        const data = await response.json()
        if (data.access_token) {
          localStorage.setItem("access_token", data.access_token)
          localStorage.setItem("email", username)
          return data // Login successful
        } else {
          return null
        }
      } else if (response.status === 401) {
        return null
      } else {
        throw new Error(`Login failed: ${response.statusText}`)
      }
    } catch (error) {
      return null
    }
  }

  const handleRegister = async () => {
    if (!firstName || !lastName || !email || !password) {
      triggerPopup("Please fill in all required fields.");
      return;
    }

    const response = await registerUser({
      email: email,
      password: password,
      first_name: firstName,
      last_name: lastName,
      org_name: orgName,
      product_name: "MAYAMAYA_LITE",
    });

    if (response.success) {
      triggerPopup("Registration successful! Please check your email for verification.");
      setIsRegisterModalOpen(false);

      {/*// Immediately attempt login using the same credentials
      const loginResponse = await login(email, password) // Use email and password directly for login
      if (loginResponse) {
        //console.log("Login successful after registration");
        setIsLoggedIn(true)
        setIsLoggedInLocal(true)
        setUsername(email) // Set the username to email
        setAccessKey(loginResponse.access_token) // Assuming access token is used as access key
        setIsModalOpen(false)
        navigate("/dashboard") */}

      // Redirect user to email verification page
      navigate(`/email-sent?email=${encodeURIComponent(email)}`);
      
    } else {
      triggerPopup(`Registration failed: ${response.error}`);
    }
};


  const handleGoogleRegister = async () => {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/authorize/google/signup`, {
        headers: {
          "Access-Control-Allow-Origin": "* ",
          "Access-Control-Allow-Headers": "Content-Type",
        },
      })
      const data = await response.json()
      if (response.ok && data.data && data.data.auth_url) {
        window.location.assign(data.data.auth_url)
      } else {
        triggerPopup("Google registration failed")
      }
    } catch (error) {
      console.error("Error during Google registration:", error)
      triggerPopup("An error occurred during Google registration")
    }
  }

  const triggerPopup = (message) => {
    setPopupMessage(message)
    setShowPopup(true)
    setTimeout(() => {
      setShowPopup(false)
    }, 3000)
  }

  // Toggle password visibility
  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  // Handle Enter key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !showGoogleRegisterForm) {
      handleRegister()
    } else if (e.key === "Enter" && showGoogleRegisterForm) {
      handleCompleteGoogleRegister()
    }
  }

  const handleClosePopup = () => {
    setShowPopup(false)
    setPopupMessage("") // Optionally clear the popup message if needed
  }

  useEffect(() => {
    const handleRedirect = () => {
      const urlParams = new URLSearchParams(window.location.search)
      const accessToken = urlParams.get("access_token")
      const email = urlParams.get("email")
      const firstName = urlParams.get("first_name")
      const lastName = urlParams.get("last_name")
      const isNewUser = urlParams.get("new_user") === "True"

      if (accessToken && email) {
        localStorage.setItem("access_token", accessToken)
        localStorage.setItem("email", email)

        if (isNewUser) {
          // It's a new user (signup)
          setGoogleUserData({ firstName, lastName, email })
          setShowGoogleRegisterForm(true)
          setIsRegisterModalOpen(true)
        } else {
          // It's an existing user (login)
          setIsLoggedIn(true)
          setIsLoggedInLocal(true)
          setUsername(email)
          setAccessKey(accessToken)
          setIsModalOpen(false)
          navigate("/dashboard")
        }

        // Clear the URL parameters
        window.history.replaceState({}, document.title, "/")
      }
    }

    handleRedirect()
  }, [])

  const handleCompleteGoogleRegister = async () => {
    if (!orgName) {
      triggerPopup("Please enter your organization name")
      return
    }
    const accessToken = localStorage.getItem("access_token")
    const email = localStorage.getItem("email")
    await updateOrgDetails(email, orgName, accessToken)
    setIsLoggedIn(true)
    setIsLoggedInLocal(true)
    setUsername(email)
    setAccessKey(accessToken)
    setIsRegisterModalOpen(false)
    setShowGoogleRegisterForm(false)
    setGoogleUserData(null)
    navigate("/dashboard")
  }

  // Add this new function to update organization details
  const updateOrgDetails = async (email, orgName, accessToken) => {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/api/user/update/org-details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          user_email: email,
          org_name: orgName,
          product_name: "MAYAMAYA_LITE",
        }),
      })

      if (!response.ok) {
        throw new Error("Failed to update organization details")
      }

      triggerPopup("Organization details updated successfully")
    } catch (error) {
      console.error("Error updating organization details:", error)
      triggerPopup("Failed to update organization details")
    }
  }

  return (
    <div className="flex min-h-screen">
      <Header
        name={name}
        setIsLoggedIn={setIsLoggedIn}
        setUsername={setUsername}
        setAccessKey={setAccessKey}
        remainingCredits={remainingCredits}
        setIsRegisterModalOpen={setIsRegisterModalOpen}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        isRegisterModalOpen={isRegisterModalOpen}
      />
      <div className="modal-content">
        <div className="modal-left">
          <img src={img || "/placeholder.svg"} alt="signup image" className="signup-image" />
          <div style={{ width: "100%" }}>
            <h1 className="headline-unique">
              Acquire, Engage and Retain Talent With{" "}
              <span style={{ color: "#672024", fontStyle: "italic" }}>MayaMaya Lite</span>
            </h1>
            <p className="subheading-unique">
              With MayaMaya Lite you can perform AI-driven resume analysis and intelligent matching for perfect job
              fits, ensuring you never miss out on top talent.
            </p>
          </div>
        </div>
        <div className="modal-right">
          <h3 style={{ fontWeight: "600", marginBottom: "20px", letterSpacing: "1.2px" }}>SIGN UP</h3>

          {!showGoogleRegisterForm ? (
            <>
              {/* Regular registration form */}
              <label style={{ fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px" }}>FIRST NAME</label>
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <label style={{ fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px" }}>LAST NAME</label>
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <label style={{ fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px" }}>EMAIL</label>
              <input
                type="text"
                placeholder="@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <label style={{ fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px" }}>PASSWORD</label>
              <div className="password-input">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <span onClick={toggleShowPassword} className="eye-icon">
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <label style={{ fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px" }}>
                ORGANIZATION NAME
              </label>
              <input
                type="text"
                placeholder="Organization Name"
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button className="modal-btn" onClick={handleRegister}>
                SIGN UP
              </button>
              <p style={{ marginTop: "15px", fontSize: "14px", color: "#555" }}>
                Already have an account?
                <a
                  href="/login"
                  style={{ color: "#5b161a", textDecoration: "none" }}
                  onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
                  onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
                >
                  <strong> Login</strong>
                </a>
              </p>
              <div class="divider">
                <span>OR</span>
              </div>
              <div
                className="google-login-container"
                style={{ marginTop: "0px", display: "flex", justifyContent: "center" }}
              >
                <button onClick={handleGoogleRegister} className="modal-btn">
                  <FaGoogle style={{ paddingTop: "5px", marginRight: "10px" }} /> Sign Up with Google
                </button>
              </div>
            </>
          ) : (
            <>
              <h3>Complete Your Registration</h3>
              <input type="text" placeholder="First Name" value={googleUserData.firstName} readOnly />
              <input type="text" placeholder="Last Name" value={googleUserData.lastName} readOnly />
              <input type="text" placeholder="Email" value={googleUserData.email} readOnly />
              <input
                type="text"
                placeholder="Organization Name"
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button className="modal-btn" onClick={handleCompleteGoogleRegister}>
                Complete Sign Up
              </button>
            </>
          )}
        </div>
      </div>
      {showPopup && (
        <div>
          <div className="overlay" onClick={handleClosePopup}></div>
          <div className="popup">
            <button className="close-btn" onClick={handleClosePopup}>
              ×
            </button>
            {popupMessage}
          </div>
        </div>
      )}
      <footer className="footer">
        <p>MayaMaya Suite of Products - MayaMaya Lite</p>
      </footer>
    </div>
  )
}

export default Signup

